import api from './api';

export const dashboardService = {
  async getDashboardStats() {
    try {
      const payload = await api.get('/api/dashboard/stats');
      return payload?.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas do dashboard:', error);
      throw error;
    }
  },

  async getTicketsCount() {
    try {
      const payload = await api.get('/api/dashboard/stats');
      return payload?.data;
    } catch (error) {
      console.error('Erro ao buscar contagem de tickets:', error);
      throw error;
    }
  },

  async getContactsCount() {
    try {
      const payload = await api.get('/api/dashboard/stats');
      return payload?.data;
    } catch (error) {
      console.error('Erro ao buscar contagem de contatos:', error);
      throw error;
    }
  },

  async getAttendantsStatus() {
    try {
      const payload = await api.get('/api/dashboard/attendants/status');
      return payload?.data;
    } catch (error) {
      console.error('Erro ao buscar status dos atendentes:', error);
      throw error;
    }
  },

  async getChartData(period = '7d') {
    try {
      const payload = await api.get(`/api/dashboard/chart?period=${period}`);
      return payload?.data;
    } catch (error) {
      console.error('Erro ao buscar dados do gráfico:', error);
      throw error;
    }
  },
  async getOverview(days = 14) {
    const payload = await api.get(`/api/dashboard/overview?days=${days}`);
    return payload?.data;
  }
};
